import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AccessService} from '../services/access.service';
import {EpasUtilService} from '../services/epas-util.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {DataManagementService} from '../services/data-management.service';
import {Constants} from '../constants';
import * as moment from 'moment';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-application-form',
    templateUrl: './application-form.component.html',
    styleUrls: ['./application-form.component.css']
})
export class ApplicationFormComponent implements OnInit, OnDestroy {
    @ViewChild('termsAndConditionsModal') termsAndConditionsModal: TemplateRef<any>;
    public modalReference: NgbModalRef;
    studentCgpa;
    studentWorkExperience;
    minCgpa;
    minWorkExperience;
    data: object;
    organisations = [];
    outgoingStudentFormData;
    isStudentRegistered = false;
    isStudentRegistrationStatusPending;
    isModifyButtonHidden = true;
    isModifyButtonDisabled;
    areInputButtonsDisabled = false;
    isPassportNotIssued = false;
    isSaveButtonHidden = true;
    modifyErrorMessage;
    activeRoundLink: string;
    activeRound: string;
    route: string;
    timer;
    errorMessage = undefined;
    timeToEnd;
    timeToStart;
    roundSettingsTimer;
    oneSecondTimer;
    inRandomTime = false;
    isRoundEnded = false;
    isRoundYetToStart = false;
    isDataReady = false;
    isDataFetched = false;
    isRoundExist = false;
    currentTime;
    currentTimeStr: string;
    startTime;
    startTimeStr: string;
    endTime;
    endTimeStr: string;
    selectUndefinedOptionValue = 0;
    universitiesList;
    refID;
    finalEndTime;
    isFinalSubmitted;

    isTermsAndConditionsChecked: any = false;

    constructor(private modal: NgbModal,
                private accessService: AccessService,
                private utilService: EpasUtilService,
                private dmService: DataManagementService,
                private router: Router,
                private toastr: ToastrService) {
        this.router.events.subscribe(event => {
            this.route = this.router.url;
        });
    }

    getFormData(): void {
        const outgoingStudentId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
        const outgoingTermId = JSON.parse(localStorage.getItem('epas_user')).term.outgoing_term_id;
        const parameter = outgoingTermId + '/' + outgoingStudentId;
        this.dmService.javaGetDataCallByParameter(Constants.STUDENT_REGISTRATION, parameter)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.outgoingStudentFormData = response.data;
                        this.isFinalSubmitted = this.outgoingStudentFormData.is_final_submitted;
                        if (this.outgoingStudentFormData.id !== 0) {
                            this.isStudentRegistered = true;
                            this.isModifyButtonHidden = false;
                            this.areInputButtonsDisabled = true;
                            if (this.outgoingStudentFormData.status_id === Constants.NO_STATUS ||
                                this.outgoingStudentFormData.status_id === Constants.PENDING ||
                                this.outgoingStudentFormData.status_id === Constants.REJECTED) {
                                this.isStudentRegistrationStatusPending = true;
                                this.isModifyButtonDisabled = false;
                                this.isSaveButtonHidden = true;
                                this.isTermsAndConditionsChecked = true;
                            } else {
                                this.isStudentRegistrationStatusPending = false;
                                this.isModifyButtonDisabled = true;
                                this.isSaveButtonHidden = true;
                                this.isTermsAndConditionsChecked = true;
                                this.modifyErrorMessage = 'Your Form is already accepted by OIA and cannot change the' +
                                    ' details now. You may contact OIA for changes.';
                            }
                        } else {
                            this.isStudentRegistered = false;
                            this.isStudentRegistrationStatusPending = true;
                            this.isModifyButtonHidden = true;
                            this.areInputButtonsDisabled = false;
                            this.isSaveButtonHidden = false;
                            this.isTermsAndConditionsChecked = false;
                        }
                        this.passportStatusChange();
                        this.organisations = response.data.organisations;
                        this.universitiesList = response.data.universities;
                        if (this.organisations === null || this.organisations === undefined || this.organisations.length === 0) {
                            this.organisations = [{}];
                        }
                    } else if (response.status === 'fail') {
                        this.errorMessage = response.message;
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                });
    }

    editModal(): void {
        this.areInputButtonsDisabled = false;
        this.isSaveButtonHidden = false;
        this.isTermsAndConditionsChecked = true;
        this.isModifyButtonHidden = true;
        this.passportStatusChange();
    }

    uploadOutgoingStudentDetails(): void {
        this.outgoingStudentFormData.organisations = this.organisations;
        this.outgoingStudentFormData.is_final_submitted = false;
        if (this.outgoingStudentFormData.outgoing_student_id === 0) {
            this.outgoingStudentFormData.outgoing_student_id =
                JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
        }
        if (this.outgoingStudentFormData.outgoing_term_id === 0) {
            this.outgoingStudentFormData.outgoing_term_id =
                JSON.parse(localStorage.getItem('epas_user')).term.outgoing_term_id;
        }
        const body = {
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id,
            data: this.outgoingStudentFormData
        };
        this.dmService.javaPostDataCall(body, Constants.STUDENT_REGISTRATION)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.toastr.success('Successfully updated the registration form.', 'Success');
                        this.getFormData();
                    } else if (response.status === 'fail') {
                        this.toastr.warning(response.message, 'Fail');
                    }
                },
                error => {
                    console.log(error);
                    this.toastr.error('Server Error', 'Error');
                });
    }

    finalSubmitRegistrationForm(e): void {
        e.preventDefault();
        if (this.isTermsAndConditionsChecked == false) {
            Swal({
                title: 'Required',
                type: 'warning',
                text: 'You need to accept the terms and conditions in order to submit your registration.'
            });
            return;
        }
        console.log(this.outgoingStudentFormData);
        this.outgoingStudentFormData.organisations = this.organisations;
        this.outgoingStudentFormData.is_final_submitted = true;
        if (this.outgoingStudentFormData.outgoing_student_id === 0) {
            this.outgoingStudentFormData.outgoing_student_id =
                JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
        }
        if (this.outgoingStudentFormData.outgoing_term_id === 0) {
            this.outgoingStudentFormData.outgoing_term_id =
                JSON.parse(localStorage.getItem('epas_user')).term.outgoing_term_id;
        }
        if (this.outgoingStudentFormData.is_accepted === 0 || this.outgoingStudentFormData.is_accepted === undefined ||
            this.outgoingStudentFormData.is_accepted === null || this.outgoingStudentFormData.is_accepted === false) {
            Swal({
                title: 'Required',
                type: 'warning',
                text: 'You need to tick the terms and conditions checkbox in order to submit your registration.'
            });
            return;
        }
        const body = {
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id,
            data: this.outgoingStudentFormData
        };
        const that = this;
        let uploadResponse;
        Swal({
            title: 'Confirm',
            type: 'question',
            text: 'You can not modify your details once the registration is submitted.' +
                ' Are you sure you want to continue?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#4cb84c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(body, Constants.FINAL_STUDENT_REGISTRATION).subscribe(data => {
                        uploadResponse = data;
                        resolve(uploadResponse);
                    }, error => {
                        uploadResponse = error;
                        reject(uploadResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (uploadResponse.status === 'success') {
                    that.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then( () =>
                        that.router.navigate(['application']));
                    if (uploadResponse.hasOwnProperty('message')) {
                        Swal({
                            title: 'Success',
                            type: 'success',
                            html: uploadResponse.message,
                        });
                    } else {
                        Swal({
                            title: 'Success',
                            type: 'success',
                            html: '<p>Successfully submitted registration.</p>',
                        });
                    }
                } else if (uploadResponse.status === 'fail') {
                    if (uploadResponse.hasOwnProperty('message')) {
                        Swal({type: 'error', title: 'Fail', html: uploadResponse.message});
                    } else {
                        Swal({type: 'error', title: 'Fail', text: 'Unable to upload registration form, Please contact support team.'});
                    }
                }
            }
        });
    }

    addOrganisation(event: Event): void {
        event.preventDefault();
        this.organisations.push({
            organisation: null,
            designation: null,
            from_date: null,
            to_date: null,
            number_of_months: null
        });
    }

    deleteOrganisation(e, organisation) {
        e.preventDefault();
        if (!organisation.hasOwnProperty('id')) {
            this.organisations.splice(this.organisations.indexOf(organisation), 1);
            return;
        }
        const body = {
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id,
            work_experience_id: organisation.id,
        };
        this.dmService.javaPostDataCall(body, Constants.DELETE_EXPERIENCE)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.organisations.splice(this.organisations.indexOf(organisation), 1);
                        if (this.organisations === null || this.organisations === undefined || this.organisations.length === 0) {
                            this.organisations = [{}];
                        }
                        this.toastr.success('Successfully removed the work experience (in months).', 'Success');
                        // this.getFormData();
                    } else if (response.status === 'fail') {
                        this.toastr.warning(response.message, 'Fail');
                    }
                },
                error => {
                    console.log(error);
                    this.toastr.error('Server Error', 'Error');
                });
    }

    passportStatusChange() {
        this.isPassportNotIssued = this.outgoingStudentFormData.passport_status === '2' ||
                                   this.outgoingStudentFormData.passport_status === 2;
        if ( this.isPassportNotIssued ) {
            this.outgoingStudentFormData.passport_number = null;
            this.outgoingStudentFormData.first_name = null;
            this.outgoingStudentFormData.last_name = null;
            this.outgoingStudentFormData.father_name = null;
            this.outgoingStudentFormData.nationality = null;
            this.outgoingStudentFormData.passport_issue_date = null;
            this.outgoingStudentFormData.passport_expiry_date = null;
        }
    }

    isStudentCgpaEligible() {
        return this.studentCgpa >= this.minCgpa;
    }

    isStudentWorkExperienceEligible() {
        return this.studentWorkExperience >= this.minWorkExperience;
    }

    refreshRoundSettings() {
        if (this.utilService.term !== undefined && this.utilService.term !== null && this.utilService.term !== '') {
            if (this.utilService.term.hasOwnProperty('registration_start_time') &&
                this.utilService.term.hasOwnProperty('registration_end_time')) {
                this.startTime = moment(this.utilService.term.registration_start_time).utcOffset('+05:30');
                this.startTimeStr = this.startTime.format('DD-MMM-YYYY, hh:mm A');
                this.endTime = moment(this.utilService.term.registration_end_time).utcOffset('+05:30');
                this.endTimeStr = this.endTime.format('DD-MMM-YYYY, hh:mm A');
                this.finalEndTime = moment(this.utilService.term.registration_end_time).utcOffset('+05:30').add(this.refID, 'seconds');
                this.isRoundExist = true;
                if (this.currentTime > this.finalEndTime) {
                    this.isRoundEnded = true;
                } else if (this.currentTime < this.startTime) {
                    this.isRoundEnded = false;
                    this.isRoundYetToStart = true;
                    this.timeToStart = moment.duration(this.startTime - this.currentTime);
                } else {
                    this.isRoundEnded = false;
                    this.isRoundYetToStart = false;
                    this.timeToEnd = moment.duration(this.endTime - this.currentTime);
                }
            }
        }
    }

    openTermsAndConditionsModal() {
        this.modalReference = this.modal.open(this.termsAndConditionsModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    closeModal(): void {
        this.modalReference.close();
    }

    getRoundDetails() {
        const studentId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
        this.utilService.refreshTerm(studentId).subscribe(
            roundDetails => {
                if (roundDetails.status === 'success') {
                    // this.utilService.term = roundDetails.data;
                    if (roundDetails.data != null) {
                        this.studentCgpa = roundDetails.data.cgpa;
                        this.studentWorkExperience = roundDetails.data.work_experience;
                        this.utilService.term = {rounds: roundDetails.data.rounds};
                        this.utilService.term.currentTime = roundDetails.data.current_time;
                        this.utilService.term.registration_start_time = roundDetails.data.term.registration_start_time;
                        this.utilService.term.registration_end_time = roundDetails.data.term.registration_end_time;

                        this.minCgpa = roundDetails.data.term.min_cgpa;
                        this.minWorkExperience = roundDetails.data.term.min_work_experience;
                        this.currentTime = moment(roundDetails.data.current_time).utcOffset('+05:30');
                        this.startTime = moment(roundDetails.data.term.registration_start_time).utcOffset('+05:30');
                        this.startTimeStr = this.startTime.format('DD-MMM-YYYY, hh:mm A');
                        this.endTime = moment(roundDetails.data.term.registration_end_time).utcOffset('+05:30');
                        this.endTimeStr = this.endTime.format('DD-MMM-YYYY, hh:mm A');
                        this.finalEndTime = moment(roundDetails.data.term.registration_end_time).
                                            utcOffset('+05:30').add(this.refID, 'seconds');
                    }
                    this.isRoundExist = true;
                } else if (roundDetails.status === 'fail' && roundDetails.data.name === 'SequelizeConnectionError') {
                    Swal({type: 'error', title: 'There\'s a problem with your internet connection'});
                } else if (roundDetails.status === 'fail') {
                    Swal({type: 'warning', title: 'Application updated', text: roundDetails.data.message});
                    this.errorMessage = roundDetails.data.message;
                }
            },
            error => {
                console.log(error);
                this.toastr.warning('Something is not right. Please refresh and reach out to contact team if' +
                    ' the issue persists', 'Fail');
            });
        if (this.route.indexOf('/application') === -1) {
            clearInterval(this.timer);
        }
    }

    calculateMonths(work) {
        let months = 0;
        if ( work.from_date !== null && work.to_date !== null ) {
            months = Math.round(moment(work.to_date, 'YYYY-MM-DD').diff(moment(work.from_date, 'YYYY-MM-DD'), 'months', true));
        }
        work.number_of_months = months;
    }

    canAccessOutgoingStudent() {
        return this.accessService.canAccessOutgoingStudent();
    }

    ngOnInit() {
        this.route = this.router.url;
        console.log(this.route);
        this.getFormData();
        this.getRoundDetails();
        this.oneSecondTimer = setInterval(() => {
            if (this.utilService.term && this.utilService.getNextActiveRoundRouterLink() !== undefined) {
                this.activeRoundLink = this.utilService.getNextActiveRoundRouterLink().split('#')[0];
                this.activeRound = this.utilService.getNextActiveRoundRouterLink().split('#')[1];
            }
            this.refreshRoundSettings();
            if (this.route.indexOf('/application') !== -1 && this.isRoundExist) {
                this.currentTime = moment(this.currentTime).utcOffset('+05:30').add({'seconds': 1});
                this.currentTimeStr = this.currentTime.format('DD-MMM-YYYY, hh:mm:ss A');
                this.inRandomTime = this.currentTime > this.endTime && this.currentTime <= this.finalEndTime;
                if (this.currentTime > this.finalEndTime) {
                    this.isRoundEnded = true;
                } else if (this.currentTime < this.startTime) {
                    this.isRoundYetToStart = true;
                    this.timeToStart = moment.duration(this.startTime - this.currentTime);
                } else {
                    if (!this.isDataFetched) {
                        this.getRoundDetails();
                        this.isDataFetched = true;
                    }
                    this.isRoundEnded = false;
                    this.isRoundYetToStart = false;
                    this.timeToEnd = moment.duration(this.endTime - this.currentTime);
                }
                this.isDataReady = true;
            }
            if (this.route.indexOf('/application') === -1) {
                clearInterval(this.oneSecondTimer);
            }
        }, 1000);
    }

    ngOnDestroy(): void {
        clearInterval(this.timer);
    }

}
